<div class="mails-container">
  <div class="header">
    <div class="flex items-center">
      <i class="pi pi-envelope text-blue-400 mr-2 text-xl"></i>
      <h2 class="text-lg font-medium">Correspondance</h2>
    </div>
    <div class="stats">
      <span class="stat-item">
        <i class="pi pi-inbox mr-1"></i>
        Total: {{ mails.length }} emails
      </span>
    </div>
  </div>

  <ng-container *ngIf="mailsLoading; else mailsContent">
    <div class="loading-state">
      <p-progressSpinner styleClass="w-8 h-8"></p-progressSpinner>
      <span>Chargement des emails...</span>
    </div>
  </ng-container>

  <ng-template #mailsContent>
    <ng-container *ngIf="(mails ?? []).length === 0; else mailsList">
      <div class="empty-state">
        <i class="pi pi-inbox text-4xl mb-2 text-gray-500"></i>
        <span class="text-lg">Aucun email disponible</span>
        <p class="text-gray-500 text-center mt-2">
          Aucune correspondance trouvée pour cette affaire.
        </p>
      </div>
    </ng-container>

    <ng-template #mailsList>
      <div class="mails-list">
        <ng-container *ngFor="let mail of mails ?? []; trackBy: trackByIndex">
          <div
            class="mail-card"
            [class.expanded]="isExpanded(mail)"
            (click)="toggleExpand(mail)"
          >
            <div class="mail-header">
              <div class="mail-sender">
                <i class="pi pi-user-edit text-blue-400 mr-2"></i>
                <span class="from">{{ mail.fromEmail }}</span>
              </div>
              <div class="mail-meta">
                <span class="date">{{
                  formatDate(mail.createdAt || mail.sentDate)
                }}</span>
                <button
                  class="expand-btn"
                  (click)="toggleExpand(mail); $event.stopPropagation()"
                >
                  <i
                    class="pi"
                    [ngClass]="
                      isExpanded(mail) ? 'pi-chevron-up' : 'pi-chevron-down'
                    "
                  ></i>
                </button>
              </div>
            </div>

            <div class="mail-subject">
              <i class="pi pi-tag mr-2 text-gray-400"></i>
              <span>{{ mail.subject || '(Pas de sujet)' }}</span>
            </div>

            <div class="mail-recipients" *ngIf="mail.recipients">
              <span class="label">À:</span>
              <span class="recipients">{{
                formatRecipients(mail.recipients)
              }}</span>
            </div>

            <div class="mail-content" *ngIf="isExpanded(mail)">
              <div
                class="content-preview"
                [innerHTML]="sanitizeHtml(mail.content)"
              ></div>

              <ng-container
                *ngIf="mail.attachments && mail.attachments.length > 0"
              >
                <div class="attachments">
                  <div class="attachments-header">
                    <i class="pi pi-paperclip mr-2"></i>
                    <span>Pièces jointes ({{ mail.attachments.length }})</span>
                  </div>
                  <div class="attachments-list">
                    <ng-container
                      *ngFor="
                        let attachment of mail.attachments;
                        trackBy: trackByIndex
                      "
                    >
                      <div class="attachment-item">
                        <i class="pi pi-file mr-2"></i>
                        <span>{{ attachment }}</span>
                      </div>
                    </ng-container>
                  </div>
                </div>
              </ng-container>
            </div>
          </div>
        </ng-container>
      </div>
    </ng-template>
  </ng-template>
</div>
